import React, { useState, useEffect, useContext } from 'react';
import { motion } from 'framer-motion';

import Input from '../../shared/components/FormElements/Input/Input';
import Button from '../../shared/components/FormElements/Button/Button';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import { VALIDATOR_REQUIRE } from '../../shared/util/validator';
import { useForm } from '../../shared/hooks/form-hook';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import './Users.css';
import MainNavigation from '../../components/MainNavigation';

const Users = () => {

  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const [loadedUser, setIsLoadedUser] = useState();

  const auth = useContext(AuthContext);

  const [isUpdated, setIsUpdated] = useState(false);

  const [formState, inputHandler, setFormData] = useForm(
    {
      firstName: {
        value: '',
        isValid: false
      },
      lastName: {
        value: '',
        isValid: false
      },
      age: {
        value: '',
        isValid: true
      },
      occupation: {
        value: '',
        isValid: true
      },
      interests: {
        value: '',
        isValid: true
      }
    },
    false
  );

  useEffect(()=>{
    setIsUpdated(false);
    const fetchUser = async () => {
      try {
        const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+`/user/${auth.userId}`);
        
        setIsLoadedUser(responseData.user);

        setFormData(
          {
            firstName: {
              value: loadedUser.firstName,
              isValid: true
            },
            lastName: {
              value: loadedUser.lastName,
              isValid: true
            },
            age: {
              value: loadedUser.age,
              isValid: true
            },
            occupation: {
              value: loadedUser.occupation,
              isValid: true
            },
            experiences: {
              value: loadedUser.experiences,
              isValid: true
            },
            projects: {
              value: loadedUser.projects,
              isValid: true
            },
            achievements: {
              value: loadedUser.achievements,
              isValid: true
            },
            interests: {
              value: loadedUser.interests,
              isValid: true
            }
          },
          true
        );
      } catch (err) {}
    };
    fetchUser();
  },[sendRequest, auth.userId, setFormData, isUpdated]);


  const userUpdateHandler = async event => {
    event.preventDefault();
    try {
      const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+`/user/${auth.userId}`, 'PATCH',
      JSON.stringify({
        firstName: formState.inputs.firstName.value,
        lastName: formState.inputs.lastName.value,
        age: formState.inputs.age.value,
        occupation: formState.inputs.occupation.value,
        experiences: formState.inputs.experiences.value,
        projects: formState.inputs.projects.value,
        achievements: formState.inputs.achievements.value,
        interests: formState.inputs.interests.value
      }),
      {'Content-Type':'application/json',
      Authorization:'Bearer '+auth.token}
      );

      setIsUpdated(true);
      setIsLoadedUser(responseData.user);

    } catch (err) {}
  };

  return (
    <React.Fragment>
    {!isLoading && <MainNavigation />}
    <div className='resume-page'>
    <ErrorModal error={error} onClear={clearError}/>
    {isLoading && <div className='center'>
        <LoadingSpinner asOverlay />
    </div>}
    {!isLoading && loadedUser && <motion.div 
      className="account-info-update"
      initial={{ opacity: 0, scale: 1 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.25, duration: 0.5 }}
      exit={{ opacity: 0, scale: 1 }}
    >
    <h1>Update Your Resume</h1>
        <p>Keep your resume updated to receive better feedbacks from vace.ai.</p>
      </motion.div>}
    {!isLoading && loadedUser && <motion.form 
      className="user-form" 
      onSubmit={userUpdateHandler}
      initial={{ opacity: 0, scale: 1, y: 1000 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 0.25, duration: 1 }}
    >
      <Input
        id="firstName"
        element="input"
        type="text"
        label="First Name"
        validators={[VALIDATOR_REQUIRE()]}
        errorText="First name is required. "
        onInput={inputHandler}
        initialValue={loadedUser.firstName}
        initialValid={true}
      />
      <Input
        id="lastName"
        element="input"
        type="text"
        label="Last Name"
        validators={[VALIDATOR_REQUIRE()]}
        errorText="Last name is required. "
        onInput={inputHandler}
        initialValue={loadedUser.lastName}
        initialValid={true}
      />
      <Input
        id="age"
        element="input"
        type="text"
        label="Age"
        placeholder="ex) 100"
        validators={[]}
        onInput={inputHandler}
        initialValue={loadedUser.age}
        initialValid={true}
      />
      <Input
        id="occupation"
        element="textarea"
        label="Education"
        placeholder="ex) [2000-2004] Interview University, Bachelor of Science (Major: Interview, Minor: AI)"
        validators={[]}
        onInput={inputHandler}
        initialValue={loadedUser.occupation}
        initialValid={true}
        rows={3}
      />
      <Input
        id="experiences"
        element="textarea"
        label="Experiences"
        placeholder="ex) [2004-2007] vace.ai, AI researcher : Descriptions"
        validators={[]}
        onInput={inputHandler}
        initialValue={loadedUser.experiences}
        initialValid={true}
        rows={5}
      />
      <Input
        id="projects"
        element="textarea"
        label="Projects"
        placeholder="ex) [2004-2007] vace.ai, AI researcher : Descriptions"
        validators={[]}
        onInput={inputHandler}
        initialValue={loadedUser.projects}
        initialValid={true}
        rows={5}
      />
      <Input
        id="achievements"
        element="textarea"
        label="Achievements"
        placeholder="ex) [2005] Best Interviewer Award"
        validators={[]}
        onInput={inputHandler}
        initialValue={loadedUser.achievements}
        initialValid={true}
        rows={5}
      />
      <Input
        id="interests"
        element="textarea"
        label="Skills/Interest"
        placeholder="ex) Interview, AI"
        validators={[]}
        onInput={inputHandler}
        initialValue={loadedUser.interests}
        initialValid={true}
        rows={5}
      />
      <div className='user-info-update-button'>
      <Button type="submit" disabled={!formState.isValid}>
        UPDATE
      </Button>
      </div>
    </motion.form>}
    </div>
    </React.Fragment>
  );
};

export default Users;
